import type { ThemeColors } from '../../../../tokens/colors/types';
import { border } from './border';
import { divider } from './divider';
import edColors from './ED';
import { blue, green, neutral, orange, pale, purple, red } from './palette';
import { deals, retail } from './product';
import { critical, info, positive, shout, warning } from './semantic';
import { typography } from './typography';

const primary = {
  '50': '#006D85',
  '10': '#F2FCFF',
  '20': '#E5FAFF',
  '30': '#63CCE3',
  '70': '#005466',
  '80': '#004352',
  '90': '#004352',
};

// TODO: This colors should be defined. For backward-compatibility they are the same as eDreams but it's wrong.
const secondary = edColors.secondary;

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  pale,
  info,
  warning,
  critical,
  positive,
  deals,
  retail,
  shout,
  border,
  divider,
  typography,
};

export default baseColors;
